import { render } from "./CreditRequestSpouse.vue?vue&type=template&id=863d5662"
import script from "./CreditRequestSpouse.vue?vue&type=script&lang=js"
export * from "./CreditRequestSpouse.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__